//Generated File 
export default class ApplicableWhen{
	static readonly All = `All`;
	static readonly DraftMode = `DraftMode`;
	static readonly NewMode = `NewMode`;
	static readonly UpdateMode = `UpdateMode`;
}
